import EnrollmentHistory from './EnrollmentHistory';

export default EnrollmentHistory;
